import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Tag,
  InputNumber,
  Select,
} from "antd";
import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router";
import useRequest from "../hooks/useRequest";
import { ToTopOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import { useNavigate } from "react-router";
const { Option } = Select;
const Search = Input.Search;
const RecycleBin = () => {
  const { request } = useRequest();
  const history = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [list, setList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const debouncedSearchText = useDebounce(searchText, 300);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [project, setProject] = useState([]);
  const [location, setLocation] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptionsProject, setSelectedOptionsProject] = useState([]);
  const [selectedOptionsType, setSelectedOptionsType] = useState([]);
  const { confirm } = Modal;
  const propertyTypes = [
    { id: 1, name: "Apartment" },
    { id: 2, name: "Villa" },
    { id: 3, name: "Townhouse" },
    { id: 4, name: "Penthouse" },
    { id: 5, name: "Compound" },
    { id: 6, name: "Duplex" },
    { id: 7, name: "Full Floor" },
    { id: 8, name: "Half Floor" },
    { id: 9, name: "Whole Building" },
    { id: 10, name: "Bulk Rent Unit" },
    { id: 11, name: "Bungalow" },
    { id: 12, name: "Hotel & Hotel Apartment" }
  ];
  const handleEdit = (record) => {
    setCurrentRecord(record);
    setIsModalVisible(true)
  };

  const handleRestore = (record) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want to restore record? </Button>,
        onOk() {
          restoreData(record)
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  const restoreData = (record) => {
    setLoading(true);
    request({
      url: `/admin/downtown/restore-file/${record ? record._id : selectedRowKeys}`,
      method: 'delete',
      onSuccess: (data) => {
        console.log(data)
        setLoading(false);
        setRefresh((prev) => !prev)
        ShowToast(data.message, Severty.SUCCESS)


      },
      onError: (error) => {
        console.log(error)
        ShowToast(error, Severty.ERROR)
      }
    })
  }

  const columns = [
    {
      title: "File Name",
      dataIndex: "file_name",
      key: "file_name",
    },
    {
      title: "Location Name",
      dataIndex: "location",
      key: "location",
      render: (_, { locationData }) => {
        return <div>{locationData ? locationData.name : "--"}</div>;
      },
    },
    {
      title: "Project Name",
      dataIndex: "project_name",
      key: "project_name",
      render: (_, { projectData }) => {
        return <div>{projectData ? projectData.name : "--"}</div>;
      },
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (_, { type }) => {
        return <div>{type ? type : "--"}</div>;
      },
    },
    {
      title: "Tag",
      dataIndex: "tag",
      key: "tag",
      render: (_, { tag }) => {
        return <div>{tag ? tag : "--"}</div>;
      },
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
    },

    {
      title: "Deleted date",
      key: "updated_at",
      dataIndex: "updated_at",
      render: (_, { updated_at }) => {
        return new Date(updated_at).toLocaleDateString();
      },
    },
    {
      title: "Action",
      fixed: "right",
      render: (_, record) => {
        return (
          <>
            <div className="cta_wrap">
              <Button title="Restore" onClick={() => handleRestore(record)}>
                <i class="fa fa-light fa-recycle"></i>
              </Button>
            </div>
          </>
        );
      },
    },
  ];
  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1 });
  };
  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
    fetchLocation()
    fetchProject()
  }, [refresh, debouncedSearchText, selectedOptions, selectedOptionsProject, selectedOptionsType]);

  const fetchData = (pagination, filters) => {
    request({
      url: `/admin/downtown/list?listType=recycle&page=${pagination ? pagination.current : 1
        }&limit=${10}&search=${debouncedSearchText}&location=${selectedOptions}&project=${selectedOptionsProject}&type=${selectedOptionsType}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        // ShowToast(data.message, Severty.SUCCESS)
        const list = data.data?.list?.docs.map((item) => ({
          key: item._id,
          ...item,
        }));
        setList(list);
        setPagination((prev) => ({
          current: pagination.current,
          total: data.data.list.totalDocs,
        }));
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (pagination, filters) => {
    console.log(pagination, filters);
    fetchData(pagination, filters);
  };
  const onSelectChange = (newSelectedRowKeys) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleClick = () => {
    history("/new-page/refine", { state: selectedRowKeys });

  }

  const fetchProject = () => {
    request({
      url: `/common/project-list`,
      method: "GET",
      onSuccess: (data) => {
        setProject(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const fetchLocation = () => {
    request({
      url: `/common/location-list`,
      method: "GET",
      onSuccess: (data) => {
        setLocation(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  const handleChangeLocation = (selectedValues) => {
    setSelectedOptions(selectedValues);
  };
  const handleChangeProject = (selectedValues) => {
    setSelectedOptionsProject(selectedValues);
  };
  const handleChangeType = (selectedValues) => {
    setSelectedOptionsType(selectedValues);
  };
  return (
    <Main>
      <div className="tabled">
        <Row>
          <Col xs="24" md={24} lg={24} xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Recycle Bin"
              extra={
                <>
                  <Search
                    className="searchbar-layout"
                    size="large"
                    onChange={onSearch}
                    value={searchText}
                    onPressEnter={onSearch}
                  />
                  {selectedRowKeys.length > 0 ? <Button onClick={() => handleRestore()} title="Delete" className="tb-view">
                    <i class="fa fa-light fa-recycle"></i>

                  </Button> : ''}
                  <Select
                    style={{
                      width: "50%",
                    }}
                    filterOption={(input, option) => {
                      console.log(option.props);
                      const inputValue = input.toLowerCase();
                      const optionLabel = option.props.children.toLowerCase();
                      return optionLabel.includes(inputValue);
                    }}
                    placeholder="Select Location"
                    mode="multiple"
                    onChange={handleChangeLocation}
                  >
                    {location && location && location.length > 0
                      ? location.map((item, index) => (
                        <Option value={item._id}>{item.name}</Option>
                      ))
                      : null}
                  </Select>
                  <Select
                    style={{
                      width: "50%",
                    }}
                    filterOption={(input, option) => {
                      console.log(option.props);
                      const inputValue = input.toLowerCase();
                      const optionLabel = option.props.children.toLowerCase();
                      return optionLabel.includes(inputValue);
                    }}
                    placeholder="Select Project"
                    mode="multiple"
                    onChange={handleChangeProject}
                  >
                    {project && project && project.length > 0
                      ? project.map((item, index) => (
                        <Option value={item._id}>{item.name}</Option>
                      ))
                      : null}
                  </Select>
                  <Select
                    style={{
                      width: "50%",
                    }}
                    filterOption={(input, option) => {
                      console.log(option.props);
                      const inputValue = input.toLowerCase();
                      const optionLabel = option.props.children.toLowerCase();
                      return optionLabel.includes(inputValue);
                    }}
                    placeholder="Select Type"
                    onChange={handleChangeType}
                  >
                    {propertyTypes && propertyTypes && propertyTypes.length > 0
                      ? propertyTypes.map((item, index) => (
                        <Option value={item.name}>{item.name}</Option>
                      ))
                      : null}
                  </Select>
                </>
              }
            >
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={pagination}
                  onChange={handleChange}
                  rowSelection={rowSelection}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      {setIsModalVisible && (
        <EditForm
          show={isModalVisible}
          hide={() => {
            setCurrentRecord();
            setIsModalVisible(false);
          }}
          data={currentRecord}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
    </Main>
  );
};


const EditForm = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [project, setProject] = useState([]);
  const [location, setLocation] = useState([]);
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 100 }, (_, i) => currentYear - i);
  const propertyTypes = [
    { id: 1, name: "Apartment" },
    { id: 2, name: "Villa" },
    { id: 3, name: "Townhouse" },
    { id: 4, name: "Penthouse" },
    { id: 5, name: "Compound" },
    { id: 6, name: "Duplex" },
    { id: 7, name: "Full Floor" },
    { id: 8, name: "Half Floor" },
    { id: 9, name: "Whole Building" },
    { id: 10, name: "Bulk Rent Unit" },
    { id: 11, name: "Bungalow" },
    { id: 12, name: "Hotel & Hotel Apartment" }
  ];
  useEffect(() => {
    fetchProject();
    fetchLocation();
  }, []);
  const fetchProject = () => {
    request({
      url: `/common/project-list`,
      method: "GET",
      onSuccess: (data) => {
        setProject(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const fetchLocation = () => {
    request({
      url: `/common/location-list`,
      method: "GET",
      onSuccess: (data) => {
        setLocation(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  useEffect(() => {
    if (data) form.setFieldsValue({ ...data });
  }, [data]);



  const onCreate = (values) => {
    setLoading(true);
    request({
      url: data
        ? `/admin/downtown/edit-file-data/${data._id}`
        : `/admin/downtown/add-downtown`,
      method: data ? "PUT" : "POST",
      data: values,
      onSuccess: () => {
        setLoading(false);
        refresh();
        hide();
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      visible={show}
      title={`${data ? "Edit" : "Create"} location`}
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Form.Item
          label="File Name"
          name="file_name"
          rules={[
            { required: true, message: "Please enter the file name!" },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Select Location"
          name="location"
          rules={[{ required: true, message: "Please select a location!" }]}
        >
          <Select placeholder="Select Location" showSearch optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }>
            {location.map((loc) => (
              <Option key={loc._id} value={loc._id}>
                {loc.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Select Project"
          name="project_name"
          rules={[{ required: true, message: "Please select a project!" }]}
        >
          <Select placeholder="Select Project" showSearch optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }>
            {project.map((proj) => (
              <Option key={proj._id} value={proj._id}>
                {proj.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Select Type"
          name="type"
          rules={[{ required: true, message: "Please select a type!" }]}
        >
          <Select placeholder="Select Type" showSearch optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }>
            {propertyTypes.map((loc) => (
              <Option key={loc.id} value={loc.name}>
                {loc.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Year" name="year">
          <Select placeholder="Select a year">
            {years.map((year) => (
              <Option key={year} value={year}>
                {year}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Tag"
          name="tag"
        ><Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default RecycleBin;
